import Switcher from "./Switcher";
import { useState, useEffect } from "react";

const Header = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        handleResize(); // set initial state
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <header className="home_header">
            <Switcher isMob={isMobile} />
        </header>
    );
};
export default Header;
